import "core-js/modules/es6.object.assign";
import { __rest } from "tslib";
import * as React from 'react';
import { Button } from '@patternfly/react-core/dist/js/components/Button';
import PencilAltIcon from '@patternfly/react-icons/dist/js/icons/pencil-alt-icon';
import CheckIcon from '@patternfly/react-icons/dist/js/icons/check-icon';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
import inlineStyles from '@patternfly/react-styles/css/components/InlineEdit/inline-edit';
import classNames from 'classnames';
export var EditColumn = function EditColumn(_a) {
  var _a$onClick = _a.onClick,
      _onClick = _a$onClick === void 0 ? null : _a$onClick,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      editing = _a.editing,
      valid = _a.valid,
      saveAriaLabel = _a.saveAriaLabel,
      cancelAriaLabel = _a.cancelAriaLabel,
      editAriaLabel = _a.editAriaLabel,
      props = __rest(_a, ["onClick", "className", "editing", "valid", "saveAriaLabel", "cancelAriaLabel", "editAriaLabel"]);

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classNames(inlineStyles.inlineEditGroup, inlineStyles.modifiers.iconGroup, 'pf-m-action-group')
  }, React.createElement("div", {
    className: classNames(inlineStyles.inlineEditAction)
  }, React.createElement(Button, Object.assign({
    "aria-label": saveAriaLabel
  }, props, {
    onClick: function onClick(e) {
      return _onClick(e, 'save');
    },
    variant: "plain"
  }), React.createElement(CheckIcon, null))), React.createElement("div", {
    className: classNames(inlineStyles.inlineEditAction)
  }, React.createElement(Button, Object.assign({
    "aria-label": cancelAriaLabel
  }, props, {
    onClick: function onClick(e) {
      return _onClick(e, 'cancel');
    },
    variant: "plain"
  }), React.createElement(TimesIcon, null)))), React.createElement("div", {
    className: classNames(inlineStyles.inlineEditAction, inlineStyles.modifiers.enableEditable)
  }, React.createElement(Button, Object.assign({
    "aria-label": editAriaLabel
  }, props, {
    onClick: function onClick(e) {
      return _onClick(e, 'edit');
    },
    variant: "plain"
  }), React.createElement(PencilAltIcon, null))));
};
EditColumn.displayName = 'EditColumn';